/**
 * Segment event names for the Orders/Bids dashboard, fired through the
 * app's `useAnalytics()` wrapper (bot-filtered + interaction-gated).
 * Names are pending Data Analytics confirmation — centralized here so a
 * rename is a one-file change.
 */

/**
 * Experiment exposure: fired once per homepage load for Premier buyers on
 * both arms; carries `variant: 'treatment' | 'control'`.
 */
export const DASHBOARD_EXPERIMENT_EXPOSURE_EVENT =
  'dashboard_experiment_exposure'

/** Module impression: the dashboard card rendered, once per mount. */
export const DASHBOARD_IMPRESSION_EVENT = 'dashboard_impression'

/** Tab interaction; carries `panel: 'bids' | 'orders'` (the clicked tab). */
export const DASHBOARD_PANEL_INTERACTION_EVENT = 'dashboard_panel_interaction'

/**
 * An outbid row was shown on the visible Bids tab; deduped per `auction_id`
 * per page-load. Carries `trigger: 'initial' | 'live' | 'resync'`.
 */
export const OUTBID_STATUS_SHOWN_EVENT = 'outbid_status_shown'

/** "Raise max bid" affordance clicked on an outbid row. */
export const REBID_CLICK_EVENT = 'rebid_click'

/** "Pay now" clicked on an awaiting-payment order row. */
export const PAY_NOW_CLICK_EVENT = 'pay_now_click'

/** "Track" clicked on a shipped order row. */
export const TRACKING_CLICK_EVENT = 'tracking_click'
